"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getProviderBadgeFields = getProviderBadgeFields;
exports.getProviderContactPhone = getProviderContactPhone;
exports.getProviderDisplayName = getProviderDisplayName;
exports.getProviderSummaryFields = getProviderSummaryFields;
exports.getSummaryFieldValues = getSummaryFieldValues;
exports.getVisitType = getVisitType;
exports.isVirtualProvider = isVirtualProvider;
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _utils = _interopRequireDefault(require("./utils"));
var _globals = require("./constants/globals");
/**
 * Given a summary with defined fields that correspond with provider data
 * and a corresponding facet config for the primary field, retrieve all summary data
 * from a provider and order it based on facet sorting rules.
 * @param {object} provider An object containing provider data.
 * @param {object[]} facets A list of facet definitions from the customer config.
 * @param {object} summary The definition of what data we want to grab from the provider.
 * @return {object[]} A sorted list of objects representing the requested summary data.
 */
function getSummaryFieldValues(provider, facets, summary) {
  let returnFields = [];
  const fieldKey = summary.field;
  const subfieldKey = summary.subfield;
  const secondarySubfieldKey = summary.secondary_subfield;
  const summaryIgnoreList = summary.ignore || [];
  let fieldData = provider[fieldKey] || [];
  if (secondarySubfieldKey) {
    const fieldDataMap = {};
    for (const data of fieldData) {
      const primaryKey = data[subfieldKey];
      fieldDataMap[primaryKey] = fieldDataMap[primaryKey] || [];
      if (data[secondarySubfieldKey]) {
        fieldDataMap[primaryKey].push(data[secondarySubfieldKey]);
      }
    }
    for (const [key, value] of (0, _entries.default)(fieldDataMap)) {
      returnFields.push({
        primary: key,
        secondary: value
      });
    }
  } else {
    if (subfieldKey) {
      const modifiedFieldData = [];
      for (const data of fieldData) {
        modifiedFieldData.push(data[subfieldKey]);
      }
      fieldData = modifiedFieldData;
    } else if (!(0, _isArray.default)(fieldData)) {
      fieldData = [fieldData];
    }
    for (const data of fieldData) {
      returnFields.push({
        primary: data
      });
    }
  }
  returnFields = (0, _filter.default)(returnFields).call(returnFields, field => (0, _indexOf.default)(summaryIgnoreList).call(summaryIgnoreList, field.primary) === -1);
  returnFields = orderedTerms(returnFields, getFacetConfig(facets, fieldKey), 'primary', false);
  returnFields = (0, _map.default)(returnFields).call(returnFields, field => {
    field.render_type = secondarySubfieldKey ? 'hierarchy' : summary.field_type;
    return field;
  });
  return returnFields;
}

/**
 * Given a list of terms, orders them based on either a custom order provided
 * by the facet config, their frequency based on facet config and passed in params,
 * or a default alphanumeric sort.
 * @param {object[]} term A list of objects to be sorted on their <valueKey> property.
 * @param {object} facetConfig A facet definition from the customer config with search rules.
 * @param {string} valueKey The property on a <term> object to sort by.
 * @param {boolean} allowFrequencySort Whether to allow frequency sort logic if facet also allows.
 * @return {object[]} The sorted terms array.
 */
function orderedTerms(terms) {
  let facetConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let valueKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  let allowFrequencySort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const {
    order_by_custom = []
  } = facetConfig;
  if (order_by_custom.length) {
    const termMap = {};
    for (const term of terms) {
      termMap[term[valueKey]] = term;
    }
    const allOrderedTerms = [];
    // I hope this is an array
    for (const orderedTerm of facetConfig.order_by_custom) {
      const term = termMap[orderedTerm];
      delete termMap[orderedTerm];
      if (term) {
        allOrderedTerms.push(term);
      }
    }
    return (0, _concat.default)(allOrderedTerms).call(allOrderedTerms, (0, _values.default)(termMap));
  } else if (facetConfig.order_by === 'frequency' && allowFrequencySort) {
    return (0, _sort.default)(terms).call(terms, (first, second) => {
      return (0, _utils.default)(first, second, 'count', true);
    });
  } else {
    return (0, _sort.default)(terms).call(terms, (first, second) => {
      return (0, _utils.default)(first, second, valueKey, false);
    });
  }
}

/**
 * Gets the facet config that corresponds with the field
 * @param {object[]} facets A list of facet definitions from the customer config.
 * @param {string} field The field to find the corresponding facert for.
 * @return {object || null} The corresponding facet or null if not available.
 */
function getFacetConfig() {
  let facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let field = arguments.length > 1 ? arguments[1] : undefined;
  for (const facet of facets) {
    if (facet.field.split('.')[0] === field) {
      return facet;
    }
  }
}

/**
 * Returns the display name of a provider.
 * @param {object} provider An object containing provider data.
 * @return {string} The providers full name with degrees appended.
 */
function getProviderDisplayName(provider) {
  let degrees = '';
  if (provider.degrees && provider.degrees.length) {
    var _context;
    const degreeNames = (0, _map.default)(_context = provider.degrees).call(_context, degree => degree.name);
    degrees = ', ' + degreeNames.join(', ');
  }
  return provider.name.full_name + degrees;
}
/**
 * Gets all customer approved badges and returns the badges that are applicable for the provider.
 * @param {object} provider An object containing provider data.
 * @param {string[]} badgeFields An array of customer approved badges from the config.
 * @return {string[]} A maximum of {MAX_BADGE_FIELDS} badges applicable to the provider.
 */
function getProviderBadgeFields(provider, badgeFields) {
  const providerBadgeFields = (0, _filter.default)(badgeFields).call(badgeFields, badgeField => provider[badgeField]);
  providerBadgeFields.length = _globals.MAX_BADGE_FIELDS;
  return providerBadgeFields;
}

/**
 * For every summary data field a provider has, get the corresponding values
 * out of the provider object, and create an array of objects containing those values
 * and the corresponding fieldName key. These objects are used to represent each column
 * in a providers summary.
 * @param {object} provider An object containing provider data.
 * @param {object[]} summaryData An array of summary objects
 * @param {object[]} facets An array of facet data from the customer config.
 * @return {Object[]} An array of summary columns.
 */
function getProviderSummaryFields(provider, summaryData, facets) {
  const providerSummary = [];
  for (const field of summaryData) {
    const values = getSummaryFieldValues(provider, facets, field);
    if (values) {
      let fieldName = field.field;
      if (field.subfield) {
        fieldName += `.${field.subfield}`;
      }
      providerSummary.push({
        field: fieldName,
        values
      });
    }
  }
  return providerSummary;
}
function isVirtualProvider(provider) {
  const visitType = getVisitType(provider);
  const hasVideoVisit = visitType[_globals.VISIT_TYPES.VIDEO];
  const isOndemandProvider = provider.provider_type === _globals.PROVIDER_TYPES.VIRTUAL_CARE;
  return hasVideoVisit || isOndemandProvider;
}

/**
 * Returns the first phone number for the provider from their contacts
 * @param {object} provider An object containing provider data.
 * @return {string | undefined} The phone number for the provider
 */
function getProviderContactPhone(provider) {
  var _context2;
  const phoneContact = (0, _find.default)(_context2 = provider.contacts).call(_context2, contact => {
    return contact.contact_type === 'phone';
  });
  if (phoneContact) {
    return phoneContact.value;
  }
  return undefined;
}

/**
 * Method to determine what visit types are available on a provider
 * Only cares about the first ehr_data in an appointment.
 * Only cares about video and phone types and breaks early when those are found;
 * other visit types are returned only as a side effect.
 * @param {object} provider An object describing a provider.
 * @return {object} An object with visit_methods as keys set to true values if encountered.
 */
function getVisitType(provider) {
  const visitType = {};
  // Short-circuit if no appointment_ehr_purposes (like "provider_type":"Virtual Care"; see KENG-13699)
  if (provider.appointment_ehr_purposes) {
    for (const appointment of provider.appointment_ehr_purposes) {
      visitType[appointment.ehr_data[0].visit_method] = true;
      // Terminate early if we got the fields we care about
      if (visitType[_globals.VISIT_TYPES.VIDEO] && visitType[_globals.VISIT_TYPES.PHONE]) {
        break;
      }
    }
  }
  return visitType;
}